import type { AccountNumber, AvtalegiroAgreementDetails, AvtalegiroProposal, Kid } from '../../../../generated-types';
import { SelectedReceiver } from '../../SelectedReceiver';

export interface AvtaleGiroState {
    toAccount?: SelectedReceiver;
    fromAccount?: AccountNumber;
    kid?: Kid;
    notification: boolean;
    transactionLimit: number;
    monthlyLimit: number;
    note?: string;
    showFromAccounts: boolean;
}

export const avtalegiroInitialState: AvtaleGiroState = {
    toAccount: undefined,
    fromAccount: undefined,
    kid: undefined,
    transactionLimit: 0,
    monthlyLimit: 0,
    notification: false,
    note: '',
    showFromAccounts: false,
};

export const getInitialState = (
    avtalegiro: AvtalegiroAgreementDetails,
    toAccount: SelectedReceiver | undefined,
): AvtaleGiroState => ({
    showFromAccounts: false,
    notification: false,
    transactionLimit: avtalegiro.limits?.transaction ?? 0,
    monthlyLimit: avtalegiro.limits?.monthly ?? 0,
    kid: avtalegiro.kid,
    fromAccount: avtalegiro.fromAccountNumber,
    toAccount: toAccount ?? { accountNumber: avtalegiro.toAccount },
    note: avtalegiro.ownText,
});

export const getProposalState = (avtalegiroProposal: AvtalegiroProposal): AvtaleGiroState => ({
    showFromAccounts: false,
    notification: false,
    transactionLimit: 0,
    monthlyLimit: 0,
    kid: avtalegiroProposal.proposal.kid,
    fromAccount: avtalegiroProposal.proposal.fromAccount,
    toAccount: { accountNumber: avtalegiroProposal.proposal.toAccountNumber },
    note: undefined,
});
